<div class="modal-header">
    <h4 class="modal-title">Unsaved changes</h4>
</div>
<div class="modal-body">
    <div class="mb-3">
        This document has unsaved changes. Would you like to save them?
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="activeModal.close(true)">Yes</button>
    <button type="button" class="btn btn-outline-dark" (click)="activeModal.close(false)">No</button>
</div>